import { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, createSvgIcon, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { ExpandMore, CloseRounded } from '@mui/icons-material';
import { fontSize, palette } from '../..';
import {
  updateAxesQueryParam,
  updateFilterSetParameter,
} from '../../redux/ChartPoperties/ChartPropertiesActions';
import {
  deleteFilterFromParameter,
  setParameterIntoFilters,
} from '../../redux/Parameters/ParametersAction';
import {
  addSourceInfoInCalculationFlow,
  setParameterId,
  setParameterRightOperand,
} from '../../redux/Calculations/CalculationsActions';
import { ICurrentCalculationSession } from '../../redux/Calculations/CurrentCalculationSessionInterface';
import { SetModifyOptions } from '../../redux/ChartPoperties/ChartControlsActions';
import { callQueryAPI } from '../../redux/ChartPoperties/ChartControlsActions';
import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import { RootState } from '../../redux';
import { IParameterSessionProps } from '../../redux/Parameters/ParameterInterface';
import {
  normalizeUserSelection,
  resolveParameterDefaultValue,
  sanitizeParameterSelections,
} from '../Parameters/utils/parameterSelectionUtils';
import { useViewport } from '@xyflow/react';

interface SelectParameterProps {
  propKey: string;
  type: string;

  calculationSession?: ICurrentCalculationSession | null;
  setSource?: Dispatch<SetStateAction<any>>;
  addParameter?: boolean;
  setAddParameter?: Dispatch<SetStateAction<boolean>>;
  conditionFilterId?: string;
  filterIdx?: number;

  filterFieldData?: any;
  currentChartAxesName?: string;
  bIndex?: number;
  itemIndex?: number;
}

const AddFunctionIcon = createSvgIcon(
  <svg
    width="100"
    height="103"
    viewBox="0 0 100 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.6652 96.08C29.1652 96.08 27.8752 95.63 26.7952 94.73C25.7152 93.89 25.2352 92.15 25.3552 89.51C25.4752 86.57 25.6852 83.51 25.9852 80.33C26.2852 77.15 26.6152 74.18 26.9752 71.42C27.7552 65.36 27.9352 60.68 27.5152 57.38C27.1552 54.02 26.2252 51.62 24.7252 50.18C23.2852 48.74 21.3352 47.78 18.8752 47.3C17.6752 47.06 16.7152 46.61 15.9952 45.95C15.2752 45.23 14.9152 44.3 14.9152 43.16C14.9152 41.66 15.5152 40.67 16.7152 40.19C17.8552 39.71 19.3252 39.47 21.1252 39.47C22.5052 39.47 24.2752 39.56 26.4352 39.74C28.6552 39.86 31.0252 39.95 33.5452 40.01C35.6452 33.11 38.0152 27.41 40.6552 22.91C43.2952 18.41 46.1752 14.87 49.2952 12.29C52.4152 9.65 55.7152 7.82 59.1952 6.8C62.6752 5.71999 66.2752 5.17999 69.9952 5.17999C74.6152 5.17999 76.9252 6.82999 76.9252 10.13C76.9252 11.75 76.1452 12.98 74.5852 13.82C73.0252 14.66 70.6552 15.35 67.4752 15.89C63.6952 16.55 60.3652 17.78 57.4852 19.58C54.6652 21.38 52.1752 23.93 50.0152 27.23C47.9152 30.53 46.0552 34.79 44.4352 40.01C52.7752 39.83 59.6152 39.38 64.9552 38.66C70.2952 37.94 74.4052 37.25 77.2852 36.59C80.2252 35.87 82.2652 35.51 83.4052 35.51C85.0252 35.51 86.0152 35.9 86.3752 36.68C86.7952 37.46 87.0052 38.3 87.0052 39.2C87.0052 40.22 86.0452 41.27 84.1252 42.35C82.8652 43.07 80.8552 43.88 78.0952 44.78C75.3352 45.62 72.0952 46.46 68.3752 47.3C64.6552 48.08 60.7252 48.74 56.5852 49.28C52.5052 49.76 48.5152 50 44.6152 50C43.6552 50 42.7852 50 42.0052 50C41.3452 53.48 40.6852 57.17 40.0252 61.07C39.4252 64.91 38.8852 68.66 38.4052 72.32C37.9252 75.98 37.5052 79.31 37.1452 82.31C36.8452 85.31 36.6652 87.71 36.6052 89.51C36.5452 91.73 35.9752 93.38 34.8952 94.46C33.8152 95.54 32.4052 96.08 30.6652 96.08Z"
      fill="#2BB9BB"
    />
    <path
      d="M50.5513 89.72C49.5273 89.72 48.7806 89.3787 48.3113 88.696C47.8419 87.9707 47.6499 87.0747 47.7353 86.008C47.7779 85.4107 48.2473 84.5573 49.1433 83.448C50.0393 82.296 51.2126 80.952 52.6633 79.416C54.1139 77.8373 55.7139 76.152 57.4633 74.36C59.2553 72.5253 61.0899 70.6693 62.9673 68.792C60.6206 65.336 58.8499 62.5627 57.6553 60.472C56.5033 58.3813 55.8846 56.7387 55.7993 55.544C55.7139 54.2213 55.9273 53.1547 56.4393 52.344C56.9939 51.5333 57.8686 51.128 59.0633 51.128C59.7459 51.128 60.4499 51.448 61.1753 52.088C61.9433 52.728 62.9033 53.9013 64.0553 55.608C65.2499 57.3147 66.8286 59.7253 68.7913 62.84C71.7353 59.896 74.1459 57.5067 76.0233 55.672C77.9433 53.7947 79.4793 52.344 80.6313 51.32C81.8259 50.296 82.7433 49.592 83.3833 49.208C84.0659 48.824 84.6419 48.632 85.1113 48.632C86.1353 48.632 86.8606 48.9947 87.2873 49.72C87.7566 50.4027 87.9486 51.2987 87.8633 52.408C87.7779 53.304 87.2446 54.392 86.2633 55.672C85.3246 56.9093 84.1086 58.2747 82.6153 59.768C81.1219 61.2187 79.5006 62.7333 77.7513 64.312C76.0446 65.848 74.3806 67.3627 72.7593 68.856C75.4046 72.6107 77.8793 75.896 80.1833 78.712C82.5299 81.4853 84.4286 83.7893 85.8793 85.624C87.3299 87.416 88.0766 88.7387 88.1193 89.592C88.2046 90.488 87.9699 91.192 87.4153 91.704C86.9033 92.216 86.1566 92.472 85.1753 92.472C84.6206 92.472 83.9379 92.28 83.1273 91.896C82.3166 91.512 81.2286 90.7227 79.8633 89.528C78.5406 88.3333 76.8339 86.5413 74.7433 84.152C72.6953 81.72 70.1353 78.456 67.0633 74.36C65.3139 76.152 63.5646 77.944 61.8153 79.736C60.1086 81.528 58.4873 83.192 56.9513 84.728C55.4579 86.2213 54.1353 87.4373 52.9833 88.376C51.8739 89.272 51.0633 89.72 50.5513 89.72Z"
      fill="#AF98DB"
    />
  </svg>,
  'AddFunction',
);

const SelectParameter = ({
  propKey,
  type,

  // calculation session is used for parameterized calculations
  calculationSession,
  setSource,
  addParameter,
  setAddParameter,

  // used for If Else condition filters in calculations
  conditionFilterId,
  filterIdx,

  // filterFieldData is used for parameterized chart filters
  filterFieldData,
  bIndex,
  currentChartAxesName,
  itemIndex,
}: SelectParameterProps) => {
  const { parameters, chartProperties, calculations } = useSelector((state: RootState) => {
    return {
      parameters: state.parameters,
      calculations: state.calculations,
      chartProperties: state.chartProperties,
    };
  });
  const dispatch = useDispatch();
  const [alert, setAlert] = useState<any>(null);

  const activeFlow: string | any = calculationSession?.activeFlow;
  const { zoom } = useViewport();
  const [parameter, setParameter] = useState<any>(() => {
    if (type === 'chartFilter') {
      return parameters?.savedParameters?.find(
        (param: any) => param.parameterId === filterFieldData?.parameterId,
      );
    } else {
      if (calculationSession?.flowParameters[activeFlow]) {
        return parameters.savedParameters.find((param: any) => {
          return calculationSession?.calculationInfo?.flows[activeFlow][0].source.find(
            (id: string) => id === param.parameterId,
          );
        });
      }
    }
  });

  const isFirstRun = useRef(true);
  const isFirstRunFilter = useRef(true);
  const boxRef = useRef<HTMLDivElement>(null);
  const [dropdownWidth, setDropdownWidth] = useState<number>(0);

  // display only parameters which are not in use and filter type is same as field type and if a picklist is selected then only display multiple selection parameters to choose
  const filterParameters = useMemo(() => {
    // Guard against missing filterFieldData for chartFilter type

    if (type === 'calculation' || (type === 'chartFilter' && !filterFieldData)) {
      return [];
    }
    if (!parameters) return [];
    return (
      parameters.savedParameters.filter((param: any) => {
        const paramType = param?.columns?.dataType;
        const filterType = filterFieldData?.dataType;
        const isAggregateFilterType = ['Aggregate Condition', 'Top N'].includes(
          filterFieldData.fieldtypeoption,
        );
        const isParamNumber = paramType === 'number' || paramType === 'decimal';
        if (isAggregateFilterType) {
          const isSingleSelection = param?.columns?.displayType?.includes('single');
          if (filterFieldData.exprType === 'between') {
            return param?.columns?.displayType?.includes('range') && isParamNumber;
          } else return isSingleSelection && isParamNumber;
        }
        const isFilterNumber = filterType === 'integer' || filterType === 'decimal';
        // return multiple selection parameters if fieldtype is pick list if date is selected
        if (
          filterFieldData?.fieldtypeoption === 'Pick List' &&
          (filterType === 'date' || filterType === 'timestamp')
        ) {
          if (filterFieldData?.prefix === 'year' || filterFieldData?.prefix === 'dayofmonth') {
            return (
              !param.columns.displayType.includes('range') &&
              isParamNumber &&
              !param?.columns?.displayType?.includes('radio') &&
              !param?.columns?.displayType?.includes('input')
            );
          } else if (filterFieldData?.prefix === 'date') {
            return (
              !param.columns.displayType.includes('range') &&
              !param?.columns?.displayType?.includes('radio') &&
              paramType === 'date' &&
              !param?.columns?.displayType?.includes('input')
            );
          }
          return (
            !param?.columns?.displayType?.includes('range') &&
            !param?.columns?.displayType?.includes('radio') &&
            paramType === 'text' &&
            !param?.columns?.displayType?.includes('input')
          );
        }

        if (
          (filterType === 'date' || filterType === 'timestamp') &&
          filterFieldData?.exprType !== 'between'
        ) {
          if (filterFieldData?.prefix === 'date') {
            return (
              !param?.columns?.displayType?.includes('range') &&
              paramType === 'date' &&
              !param?.columns?.displayType?.includes('multiple')
            );
          }
          return (
            isParamNumber &&
            !param?.columns?.displayType?.includes('range') &&
            !param?.columns?.displayType?.includes('multiple')
          );
        }

        // return multiple selection parameters if fieldtype is pick list
        if (filterFieldData?.fieldtypeoption === 'Pick List') {
          return (
            (isParamNumber && isFilterNumber) ||
            (!param?.columns?.displayType?.includes('radio') &&
              paramType === filterType &&
              !param?.columns?.displayType?.includes('input'))
          );
        }

        // return range parameters if exprType is between
        if (filterFieldData?.exprType === 'between') {
          return (
            ((isParamNumber && isFilterNumber) ||
              paramType === filterType ||
              filterType === 'date' ||
              filterType === 'timestamp') &&
            param.columns.displayType.includes('range')
          );
        }

        // return all parameters if exprType is not between but with similar datatype
        return (
          ((isParamNumber && isFilterNumber) || paramType === filterType) &&
          !param?.columns?.displayType?.includes('range') &&
          !param?.columns?.displayType?.includes('multiple')
        );
      }) || []
    );
  }, [
    chartProperties?.properties?.[propKey]?.chartAxes?.[0]?.fields,
    parameters?.savedParameters,
    filterFieldData?.prefix,
  ]);

  const calculationParameters = useMemo(() => {
    if (type !== 'calculation') return [];

    const filterType = calculationSession?.activeFlowType?.toLowerCase();
    let filters: string | any;
    let filterTypeOfLeftOperand: string | any;
    let dataTypeOfLeftOperand: string | any;
    let timeGrain: string | any;
    let operator: string | any;

    // if conditionFilterId and filterIdx are present then it is for If Else condition filters
    if (conditionFilterId && filterIdx !== undefined) {
      filters =
        calculationSession?.calculationInfo?.conditionFilters[conditionFilterId][0].conditions[
          filterIdx
        ].leftOperand[0];
      filterTypeOfLeftOperand =
        calculationSession?.calculationInfo?.conditionFilters[conditionFilterId][0].conditions[
          filterIdx
        ].leftOperandType[0];
      timeGrain =
        calculationSession?.calculationInfo?.conditionFilters[conditionFilterId][0].conditions[
          filterIdx
        ].timeGrain;
      operator =
        calculationSession?.calculationInfo?.conditionFilters[conditionFilterId][0].conditions[
          filterIdx
        ].operator;
      if (filterTypeOfLeftOperand === 'flow') {
        dataTypeOfLeftOperand =
          calculationSession?.calculationInfo?.flows[filters]?.[0]?.resultantDatatype;
      } else dataTypeOfLeftOperand = calculationSession?.calculationInfo?.fields[filters]?.dataType;
    }

    return (
      parameters?.savedParameters?.filter((param: any) => {
        const paramType = param?.columns?.dataType;
        const isParamNumber = paramType === 'number' || paramType === 'decimal';
        const isCalNumber = filterType === 'number' || filterType === 'decimal';

        if (filterType === 'condition') {
          if (dataTypeOfLeftOperand === 'date' || dataTypeOfLeftOperand === 'timestamp') {
            if (timeGrain === 'date') {
              if (operator === 'between') {
                return (
                  param?.columns?.displayType?.includes('range') &&
                  (paramType === 'date' || paramType === 'timestamp')
                );
              }
              return (
                !param?.columns?.displayType?.includes('range') &&
                paramType === 'date' &&
                !param?.columns?.displayType?.includes('multiple')
              );
            }
            if (operator === 'between') {
              return param?.columns?.displayType?.includes('range') && isParamNumber;
            }
            return (
              isParamNumber &&
              !param?.columns?.displayType?.includes('range') &&
              !param?.columns?.displayType?.includes('multiple')
            );
          }

          if (
            (paramType === 'number' && ['integer', 'decimal'].includes(dataTypeOfLeftOperand)) ||
            paramType === dataTypeOfLeftOperand
          ) {
            const notUsedInCurrentFlow = calculationSession?.calculationInfo?.conditionFilters[
              conditionFilterId!
            ]?.[0]?.conditions[filterIdx!]?.parameterId.includes(param.parameterId);
            if (operator === 'between') {
              return (
                param?.columns?.displayType?.includes('range') &&
                !notUsedInCurrentFlow &&
                paramType !== 'date'
              );
            }
            return (
              !param?.columns?.displayType?.includes('range') &&
              !param?.columns?.displayType?.includes('multiple') &&
              !notUsedInCurrentFlow &&
              paramType !== 'date'
            );
          }
        } else {
          const notUsedInCurrentFlow = calculationSession?.calculationInfo?.flows[
            activeFlow
          ]?.[0]?.parameter.find((p: any) => p.parameterId === param.parameterId);
          if (isParamNumber && isCalNumber && !notUsedInCurrentFlow) {
            return (
              !param?.columns?.displayType?.includes('range') &&
              !param?.columns?.displayType?.includes('multiple')
            );
          }
        }
        return false;
      }) || []
    );
  }, [
    calculations?.savedCalculations,
    type,
    parameters?.savedParameters,
    calculationSession?.calculationInfo?.conditionFilters[conditionFilterId!]?.[0]?.conditions[
      filterIdx!
    ]?.timeGrain,
  ]);

  const allParameters = useMemo(() => {
    return type === 'chartFilter' ? filterParameters : calculationParameters;
  }, [filterParameters, calculationParameters]);

  const updateUserFilterItem = (
    propKey: string,
    bIndex: number,
    itemIndex: number,
    field: any,
    axesName: string,
  ) => {
    dispatch(updateAxesQueryParam(propKey, bIndex, itemIndex, field, axesName));
    dispatch(callQueryAPI(propKey, true));
  };

  // handle select parameter Update the filterFieldData with the selected parameter and add filterFieldData UID to the parameter to be used in the chart filter
  const handleSelectParameter = (e: any) => {
    const rawValue = e.target.value;
    if (!rawValue) return;

    let param: any;
    if (typeof rawValue === 'string') {
      param = allParameters.find((p: any) => p.parameterId === rawValue);
    } else if (typeof rawValue === 'object' && rawValue !== null) {
      param = rawValue;
    }
    if (!param) return;

    const paramId: string = param.parameterId;

    // if its in a parameterized chart filter then bIndex, currentChartAxesName, itemIndex and filterFieldData are required
    if (type === 'chartFilter') {
      if (
        !(
          bIndex !== undefined &&
          currentChartAxesName &&
          itemIndex !== undefined &&
          filterFieldData
        )
      )
        return;

      if (filterFieldData?.parameterId)
        dispatch(deleteFilterFromParameter(propKey, filterFieldData.uId, currentChartAxesName)); // clear previous linked parameter states

      // if (!param.showParameter) {
      //   filterFieldData.userSelection = [];
      //   updateUserFilterItem(propKey, bIndex, itemIndex, filterFieldData, currentChartAxesName);
      // }

      setParameter(param);
      dispatch(
        updateFilterSetParameter(
          propKey,
          bIndex,
          currentChartAxesName,
          filterFieldData.uId,
          paramId,
        ),
      );
      dispatch(
        setParameterIntoFilters(
          propKey,
          paramId,
          filterFieldData.uId,
          itemIndex,
          currentChartAxesName,
        ),
      );
      dispatch(SetModifyOptions(propKey, 'filter', filterFieldData.uId));
      if (
        filterFieldData.isParameterized //&&
        // checkboxValues.length > 0
      ) {
        filterFieldData.parameterId = paramId;
        if (param.columns?.displayType === 'checkbox (multiple selection)') {
          const rawSelection = param.userSelection
            ? param.userSelection
            : param.columns.defaultValue
              ? [param.columns.defaultValue]
              : [];

          const normalized = normalizeUserSelection(param.columns?.displayType, rawSelection);
          console.log(normalized);
          const validatedSelection =
            normalized.kind === 'array'
              ? sanitizeParameterSelections(normalized.values, {
                  dataType: param.columns?.dataType,
                  values: param.values,
                  minValue: param.minValue,
                  maxValue: param.maxValue,
                })
              : [];

          filterFieldData.userSelection = validatedSelection;
        }

        if (param.columns?.displayType === 'radio (single selection)') {
          const rawValue = param.userSelection
            ? param.userSelection
            : param.columns.defaultValue
              ? [param.columns.defaultValue]
              : [];
          const normalized = normalizeUserSelection(param.columns?.displayType, rawValue);
          console.log(normalized);
          const candidate =
            normalized.kind === 'normal'
              ? normalized.value
              : normalized.kind === 'array'
                ? normalized.values[0]
                : null;
          const validatedValue = resolveParameterDefaultValue(candidate, {
            dataType: param.columns?.dataType,
            values: param.values,
            minValue: param.minValue,
            maxValue: param.maxValue,
          });

          filterFieldData.exprInput = validatedValue ?? '';
        }

        if (param.columns?.displayType === 'slider (single selection)') {
          let sliderValue: any = param.userSelection
            ? param.userSelection
            : Number(param.columns?.defaultValue || param.minValue);

          if (
            (param.columns?.dataType === 'number' || param.columns?.dataType === 'decimal') &&
            param.minValue !== undefined &&
            param.maxValue !== undefined
          ) {
            const numVal = Number(sliderValue);
            if (numVal < Number(param.minValue) || numVal > Number(param.maxValue)) {
              sliderValue = Number(param.minValue);
            }
          }

          filterFieldData.exprInput = sliderValue;
        }

        if (
          param.columns?.displayType === 'range (range selection)' ||
          param.columns?.displayType === 'calendar (range selection)'
        ) {
          let value1: any, value2: any;
          if (param.columns?.displayType === 'range (range selection)') {
            let rangeValue = param.userSelection
              ? param.userSelection
              : [
                  param.columns.defaultValueMin
                    ? Number(param.columns.defaultValueMin)
                    : Number(param.minValue),
                  Number(param.columns.defaultValue),
                  param.columns.defaultValueMax
                    ? Number(param.columns.defaultValueMax)
                    : Number(param.maxValue),
                ];

            if (param.minValue !== undefined && param.maxValue !== undefined) {
              const min = Number(param.minValue);
              const max = Number(param.maxValue);
              rangeValue[0] = Math.max(min, Math.min(max, Number(rangeValue[0])));
              rangeValue[2] = Math.max(min, Math.min(max, Number(rangeValue[2])));
            }

            value1 = rangeValue[0];
            value2 = rangeValue[2];
          }
          if (param.columns?.displayType === 'calendar (range selection)') {
            let rangeValue = param.userSelection
              ? [new Date(param.userSelection[0]), new Date(param.userSelection[1])]
              : [new Date(param.minValue), new Date(param.maxValue)];

            if (param.minValue && param.maxValue) {
              const minDate = new Date(param.minValue);
              const maxDate = new Date(param.maxValue);
              if (rangeValue[0] < minDate) rangeValue[0] = minDate;
              if (rangeValue[0] > maxDate) rangeValue[0] = maxDate;
              if (rangeValue[1] < minDate) rangeValue[1] = minDate;
              if (rangeValue[1] > maxDate) rangeValue[1] = maxDate;
            }

            value1 = rangeValue[0].toISOString().slice(0, 10);
            value2 = rangeValue[1].toISOString().slice(0, 10);
          }

          Object.defineProperty(filterFieldData, 'greaterThanOrEqualTo', {
            value: value1,
            writable: true,
            enumerable: true,
            configurable: true,
          });
          Object.defineProperty(filterFieldData, 'lessThanOrEqualTo', {
            value: value2,
            writable: true,
            enumerable: true,
            configurable: true,
          });
        }

        if (
          param.columns?.displayType === 'calendar (single selection)' ||
          param.columns?.displayType?.includes('input') ||
          param.columns?.displayType?.includes('radio')
        ) {
          let value: any;
          if (param.columns?.displayType === 'calendar (single selection)') {
            let calendarValue = param.userSelection
              ? new Date(param.userSelection)
              : param.columns.defaultValue
                ? new Date(param.columns.defaultValue as string)
                : new Date(param.minValue);

            // Validate calendar value is within min/max range
            if (param.minValue && param.maxValue) {
              const minDate = new Date(param.minValue);
              const maxDate = new Date(param.maxValue);
              if (calendarValue < minDate) calendarValue = minDate;
              if (calendarValue > maxDate) calendarValue = maxDate;
            }

            value = calendarValue?.toISOString().slice(0, 10);
          } else if (param.columns?.displayType?.includes('input')) {
            value = param.userSelection ? param.userSelection : param?.columns?.defaultValue || '';
            filterFieldData.userSelection = [value];
          } else {
            value = param.userSelection ? param.userSelection : param?.columns?.defaultValue || '';

            if (value) {
              const dataType = param.columns?.dataType;
              if (param.values && param.values.length > 0) {
                if (!param.values.includes(value)) {
                  value = '';
                }
              } else if (
                (dataType === 'number' || dataType === 'decimal') &&
                param.minValue !== undefined &&
                param.maxValue !== undefined
              ) {
                const numVal = Number(value);
                if (numVal < Number(param.minValue) || numVal > Number(param.maxValue)) {
                  value = '';
                }
              } else if (dataType === 'date' && param.minValue && param.maxValue) {
                const d = new Date(value);
                if (d < new Date(param.minValue) || d > new Date(param.maxValue)) {
                  value = '';
                }
              }
            }
          }

          if (filterFieldData.fieldtypeoption !== 'Pick List') {
            filterFieldData.exprInput = value;
          }
        }

        if (param.columns?.displayType?.includes('switch')) {
          const active = param.userSelection
            ? param?.userSelection === 'True'
              ? true
              : false
            : (param.columns?.defaultValue as boolean);
          const value = active ? 'True' : 'False';
          filterFieldData.userSelection = [value];
        }
        updateUserFilterItem(propKey, 0, itemIndex, filterFieldData, currentChartAxesName);
      }
      dispatch(callQueryAPI(propKey, true));
    } else {
      // Handle calculation type
      if (param?.columns?.has_calculation) {
        setAlert({
          severity: 'warning',
          message:
            'This parameter is already linked with a calculation. Please delete the calculation and try again.',
        });
        return;
      }

      const index = calculationSession?.calculationInfo.flows[activeFlow][0].source
        .length as number;
      const flowName = calculationSession?.calculationInfo.flows[activeFlow][0].flow as string;
      const dataType = param.columns.dataType === 'number' ? 'integer' : param.columns.dataType;
      const flowAggregation = flowName === 'min' || flowName === 'max' ? false : true;

      let source: any = param.columns.defaultValue
        ? param.columns.defaultValue
        : dataType === 'text'
          ? ''
          : flowName === 'division' || flowName === 'multiplication'
            ? 1
            : 0;

      if (flowName === 'IfElse') {
        const isBetween =
          calculationSession?.calculationInfo?.conditionFilters[conditionFilterId as string][0]
            .conditions[filterIdx as number].operator === 'between';
        if (isBetween) {
          source = [param.minValue, param.maxValue];
        }
        setSource!([paramId]);
      } else {
        setSource!((prev: any) => [
          ...prev,
          {
            id: paramId,
          },
        ]);
      }

      if (flowName === 'IfElse') {
        dispatch(
          setParameterRightOperand(
            propKey,
            conditionFilterId as string,
            filterIdx as number,
            source,
            dataType,
            paramId,
          ),
        );
      } else {
        dispatch(
          addSourceInfoInCalculationFlow(
            source,
            {
              uid: activeFlow,
              flow: calculationSession?.calculationInfo?.flows[activeFlow][0]?.flow as string,
            },
            propKey,
            dataType,
            flowAggregation,
            'sum',
            0,
          ),
        );

        dispatch(
          setParameterId(
            propKey,
            paramId,
            flowName === 'log' ? index - 1 : index, // set the index according to the source index to perform operations
          ),
        );
      }
      setParameter(param);

      typeof setAddParameter === 'function' && setAddParameter(false); // reset add parameter state after selecting a parameter
    }
  };

  const clearLinkedParameterStates = () => {
    if (type === 'chartFilter') {
      if (
        !(
          bIndex !== undefined &&
          currentChartAxesName &&
          itemIndex !== undefined &&
          filterFieldData
        )
      )
        return;
      dispatch(deleteFilterFromParameter(propKey, filterFieldData.uId, currentChartAxesName));
      dispatch(
        updateFilterSetParameter(propKey, bIndex, currentChartAxesName, filterFieldData.uId, ''),
      );
      dispatch(callQueryAPI(propKey, true));
      setParameter(null);
    }
  };

  // unPlug parameter when exprType changes or field type changes
  useEffect(() => {
    // Only run for chartFilter type and guard against missing dependencies
    if (type !== 'chartFilter') {
      return;
    }
    if (
      !(bIndex !== undefined && currentChartAxesName && itemIndex !== undefined && filterFieldData)
    )
      return;

    if (isFirstRunFilter.current) {
      isFirstRunFilter.current = false;
      return;
    }

    const exprType = filterFieldData.exprType;
    const fieldTypeOption = filterFieldData.fieldtypeoption;
    const displayType = parameter?.columns?.displayType || '';

    if (exprType !== 'between' && displayType.includes('range')) {
      clearLinkedParameterStates();
    }
    if (exprType === 'between' && !displayType.includes('range')) {
      clearLinkedParameterStates();
    }
    if (fieldTypeOption === 'Pick List' && !displayType.includes('multiple')) {
      clearLinkedParameterStates();
    }
    if (fieldTypeOption !== 'Pick List' && displayType.includes('multiple')) {
      clearLinkedParameterStates();
    }

    filterFieldData.userSelection = [];
    dispatch(updateAxesQueryParam(propKey, 0, itemIndex!, filterFieldData, currentChartAxesName));
  }, [filterFieldData?.exprType, filterFieldData?.fieldtypeoption]);

  //  unPlug parameter when date prefix value changes
  useEffect(() => {
    // Only run for chartFilter type and guard against missing dependencies
    if (type !== 'chartFilter' || !filterFieldData) {
      return;
    }

    // Prevent this block from running on initial mount
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    const dataType = filterFieldData.dataType;
    const exprType = filterFieldData.exprType;

    if (dataType === 'date' || (exprType === 'between' && dataType === 'date')) {
      clearLinkedParameterStates();
    }

    if (!filterFieldData.parameterId) {
      setParameter(null);
    }
  }, [filterFieldData?.prefix, filterFieldData?.dataType, type]);

  useEffect(() => {
    // Only run for chartFilter type and guard against missing dependencies
    if (type !== 'chartFilter') {
      return;
    }
    if (
      !(bIndex !== undefined && currentChartAxesName && itemIndex !== undefined && filterFieldData)
    )
      return;

    const para = parameters.savedParameters.find(
      (param: any) => param?.parameterId === filterFieldData.parameterId,
    );
    if (para) {
      setParameter(para);
      dispatch(
        setParameterIntoFilters(
          propKey,
          para.parameterId,
          filterFieldData.uId,
          itemIndex,
          currentChartAxesName,
        ),
      );
    }

    if (!filterFieldData.parameterId) {
      setParameter(null);
    }
  }, [propKey, filterFieldData?.parameterId]);

  useEffect(() => {
    if (addParameter && boxRef.current) {
      const width = boxRef.current.offsetWidth;
      setDropdownWidth(width);
    }
  }, [addParameter]);

  return (
    <Box
      ref={boxRef}
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: type === 'calculation' ? '1px solid #d3d3d3' : 'none',
        '&:hover': {
          border: type === 'calculation' ? '1px solid #7a7a7a' : 'none',
        },
        // borderRadius: type === 'calculation' ? '3px' : '3.5',
        height: '1.5rem',
        width: '100%',
        margin: '0 auto',
      }}
    >
      {addParameter && (
        <button
          type="button"
          className="buttonCommon columnClose"
          title="Remove field"
          onClick={() => {
            typeof setAddParameter === 'function' && setAddParameter(false);
          }}
          style={{
            width: '13px',
            height: '13px',
            flexShrink: 0,
            marginLeft: '4px',
            marginRight: '4px',
          }}
        >
          <CloseRounded style={{ fontSize: fontSize.semiLarge, display: 'block' }} />
        </button>
      )}
      <FormControl
        sx={{
          height: type === 'calculation' ? 'auto' : '1.5rem',
          width: '100%',
          marginTop: type !== 'calculation' ? '10px' : '0px',
          '& .MuiOutlinedInput-root': {
            border: addParameter ? 'none' : '1px solid #d3d3d3',
            borderRadius: '3.5px',
            '& fieldset': {
              border: 'none !important',
            },
            '&:hover': {
              border: type !== 'calculation' ? '1px solid #7a7a7a' : 'none',
            },

            '&.Mui-focused': {
              border: type !== 'calculation' ? '1px solid #7a7a7a' : 'none',
            },
          },
        }}
      >
        <Select
          displayEmpty
          value={parameter?.parameterId ?? ''}
          onChange={handleSelectParameter}
          size="small"
          MenuProps={{
            PaperProps:
              type !== 'calculation'
                ? {
                    style: {
                      maxHeight: 270,
                      width: addParameter ? dropdownWidth : 30,
                      overflowY: 'auto',
                    },
                  }
                : {},
            slotProps:
              type === 'calculation'
                ? {
                    paper: {
                      sx: {
                        transform: `scale(${zoom}) !important`,
                      },
                    },
                  }
                : {},
          }}
          sx={{
            height: '1.5rem',
            fontSize: fontSize.medium,
            textAlign: 'left',
            '.MuiSelect-icon': {
              // fontSize: fontSize.TripleExtraLarge,
              // color: palette.primary.contrastText,
              right: '1px',
              marginRight: type === 'chartFilter' ? '0rem' : '0.4rem',
            },
          }}
          renderValue={(selected) => {
            if (!selected || selected.length === 0) {
              return <span style={{ color: '#aaa', fontSize: '12px' }}>Select parameter</span>;
            }
            const selectedParam = allParameters.find(
              (p: IParameterSessionProps) => p.parameterId === selected,
            );
            return selectedParam?.name ?? selected;
          }}
          IconComponent={ExpandMore}
        >
          {allParameters.length > 0 ? (
            allParameters.map((option) => (
              <MenuItem
                key={option.parameterId}
                value={option.parameterId}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0.2rem 0.5rem',
                  overflow: 'hidden',
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(43, 185, 187, 0.1)',
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: 'rgba(43, 185, 187, 0.2)',
                  },
                }}
              >
                <Typography
                  sx={{
                    width: 'auto',
                    // minWidth: '100%',
                    // overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: fontSize.small,
                  }}
                >
                  {option.name}
                </Typography>
                {option.columns?.has_calculation && (
                  <Box>
                    <AddFunctionIcon
                      sx={{
                        fontSize: fontSize.medium,
                      }}
                    />
                  </Box>
                )}
              </MenuItem>
            ))
          ) : (
            <MenuItem
              sx={{
                paddingY: '0px',
                paddingX: '0.5rem',
                '&:hover': {
                  backgroundColor: 'transparent',
                },
                cursor: 'default',
              }}
            >
              <Typography
                sx={{
                  width: 'auto',
                  minWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: fontSize.extraSmall,
                  color: 'rgb(92, 93, 94)',
                }}
              >
                No parameter of this data type found
              </Typography>
            </MenuItem>
          )}
        </Select>
      </FormControl>

      {alert && (
        <NotificationDialog
          severity={alert.severity}
          openAlert={alert}
          onCloseAlert={() => setAlert(null)}
          testMessage={alert.message}
        />
      )}
    </Box>
  );
};

export default SelectParameter;
